import {Injectable} from "@angular/core";
import {TableOptionsService} from "@app/_services/table-options.service";
import {MasterDataLoadRun} from "@app/_models/api";
import {GlobalService} from "@app/_services/global.service";

@Injectable({
    providedIn: 'root'
})
export class MasterDataLoadsService extends TableOptionsService<MasterDataLoadRun> {

    constructor(globalService: GlobalService) {
        super();
        this.pageSize = globalService.pagination[0];
        this.sortColumn = 'createdAt';
        this.sortDirection = 'desc';
    }

    public override matches(element: MasterDataLoadRun, term: string) {
        const t = term.toLowerCase();
        return (
            element.status?.toLowerCase().includes(t) ||
            (element.triggeredByName?.toLowerCase().includes(t) ?? false)
        );
    }
}
